import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5000;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const show = () => {
      setOpen(true);
      timeout = window.setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      setOpen(false);
      setIndex(i => (i + 1) % purchaseNotifications.length);
      timeout = window.setTimeout(show, GAP_MS);
    };
    timeout = window.setTimeout(show, FIRST_DELAY);
    return () => window.clearTimeout(timeout);
  }, [dismissed]);
  const item = purchaseNotifications[index];
  const minutes = index * 3 % 11 + 2;
  return <div aria-live="polite" className="pointer-events-none fixed left-3 right-3 top-3 z-50 flex justify-start sm:left-4 sm:right-auto sm:top-auto sm:bottom-24" data-id="element-39" data-mp="165pm8exqiye0">
      <AnimatePresence data-id="element-40" data-mp="1151x5yt2grmf">
        {open && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -8,
        scale: 0.98
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-[22rem] items-start gap-3 rounded-xl border border-ink-900/10 bg-white p-3 shadow-xl" data-id="element-41" data-mp="1fuhb2e7i12kp">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-green-100" data-id="element-42" data-mp="x2ya0cx1bylb">
              <CheckCircle2Icon className="h-5 w-5 text-green-600" aria-hidden="true" data-id="element-43" data-mp="28k7qqros4cix" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-44" data-mp="23lmybefrqx51">
              <p className="text-sm font-bold leading-snug text-ink-900" data-id="element-45" data-mp="23kv3i5tzx3ft">
                {item.name} from {item.country}
              </p>
              <p className="text-xs leading-snug text-ink-600" data-id="element-46" data-mp="2fnnzx68t53y1">
                just purchased the Premium Technician Kit™
              </p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-steel-500" data-id="element-47" data-mp="2knsg0v5szwnq">
                {minutes} minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="shrink-0 rounded-md p-1 text-steel-500 transition-colors duration-150 ease-out hover:bg-steel-100 hover:text-ink-900" data-id="element-48" data-mp="1ryll065k5p78">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-49" data-mp="26nhtg4bj148d" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}